export const TwoWheelerSalesData = [
  {
    id: "Two wheeler sales",
    color: "hsl(119, 70%, 50%)",
    data: [
      { x: "Apr-2015", y: "-0.16" },
      { x: "May-2015", y: "-1.25" },
      { x: "Jun-2015", y: "3.55" },
      { x: "Jul-2015", y: "0.14" },
      { x: "Aug-2015", y: "-2.98" },
      { x: "Sep-2015", y: "-1.06" },
      { x: "Oct-2015", y: "13.31" },
      { x: "Nov-2015", y: "1.47" },
      { x: "Dec-2015", y: "-3.1" },
      { x: "Jan-2016", y: "2.63" },
      { x: "Feb-2016", y: "12.76" },
      { x: "Mar-2016", y: "10.92" },
      { x: "Apr-2016", y: "21.23" },
      { x: "May-2016", y: "9.66" },
      { x: "Jun-2016", y: "12.28" },
      { x: "Jul-2016", y: "13.52" },
      { x: "Aug-2016", y: "26.32" },
      { x: "Sep-2016", y: "21.76" },
      { x: "Oct-2016", y: "8.72" },
      { x: "Nov-2016", y: "-5.85" },
      { x: "Dec-2016", y: "-22.04" },
      { x: "Jan-2017", y: "-7.39" },
      { x: "Feb-2017", y: "-0.01" },
      { x: "Mar-2017", y: "0.27" },
      { x: "Apr-2017", y: "7.34" },
      { x: "May-2017", y: "11.95" },
      { x: "Jun-2017", y: "4.04" },
      { x: "Jul-2017", y: "13.79" },
      { x: "Aug-2017", y: "14.73" },
      { x: "Sep-2017", y: "9.12" },
      { x: "Oct-2017", y: "-2.72" },
      { x: "Nov-2017", y: "23.55" },
      { x: "Dec-2017", y: "41.47" },
      { x: "Jan-2018", y: "33.48" },
      { x: "Feb-2018", y: "23.8" },
      { x: "Mar-2018", y: "18.39" },
      { x: "Apr-2018", y: "16.96" },
      { x: "May-2018", y: "9.16" },
      { x: "Jun-2018", y: "22.28" },
      { x: "Jul-2018", y: "8.19" },
      { x: "Aug-2018", y: "2.94" },
      { x: "Sep-2018", y: "4.12" },
      { x: "Oct-2018", y: "17.23" },
      { x: "Nov-2018", y: "7.15" },
      { x: "Dec-2018", y: "-2.23" },
      { x: "Jan-2019", y: "-5.18" },
      { x: "Feb-2019", y: "-4.22" },
      { x: "Mar-2019", y: "-17.32" },
      { x: "Apr-2019", y: "-16.36" },
      { x: "May-2019", y: "-6.73" },
      { x: "Jun-2019", y: "-11.69" },
      { x: "Jul-2019", y: "-16.82" },
      { x: "Aug-2019", y: "-22.24" },
      { x: "Sep-2019", y: "-22.09" },
      { x: "Oct-2019", y: "-14.43" },
      { x: "Nov-2019", y: "-14.27" },
      { x: "Dec-2019", y: "-16.6" },
      { x: "Jan-2020", y: "-16.06" },
      { x: "Feb-2020", y: "-19.82" },
      { x: "Mar-2020", y: "-39.83" },
    ],
  },
]

export const carSalesData = [
  {
    id: "Car sales",
    color: "hsl(119, 70%, 50%)",
    data: [
      {
        x: "Apr-2015",
        y: "18.17",
      },
      {
        x: "May-2015",
        y: "7.94",
      },
      {
        x: "Jun-2015",
        y: "1.51",
      },
      {
        x: "Jul-2015",
        y: "17.47",
      },
      {
        x: "Aug-2015",
        y: "5.58",
      },
      {
        x: "Sep-2015",
        y: "9.48",
      },
      {
        x: "Oct-2015",
        y: "21.8",
      },
      {
        x: "Nov-2015",
        y: "10.39",
      },
      {
        x: "Dec-2015",
        y: "12.87",
      },
      {
        x: "Jan-2016",
        y: "-0.72",
      },
      {
        x: "Feb-2016",
        y: "-4.16",
      },
      {
        x: "Mar-2016",
        y: "-0.31",
      },
      {
        x: "Apr-2016",
        y: "1.87",
      },
      {
        x: "May-2016",
        y: "-0.86",
      },
      {
        x: "Jun-2016",
        y: "-5.18",
      },
      {
        x: "Jul-2016",
        y: "9.64",
      },
      {
        x: "Aug-2016",
        y: "9.53",
      },
      {
        x: "Sep-2016",
        y: "15.14",
      },
      {
        x: "Oct-2016",
        y: "0.45",
      },
      {
        x: "Nov-2016",
        y: "0.29",
      },
      {
        x: "Dec-2016",
        y: "-8.14",
      },
      {
        x: "Jan-2017",
        y: "10.87",
      },
      {
        x: "Feb-2017",
        y: "4.97",
      },
      {
        x: "Mar-2017",
        y: "8.27",
      },
      {
        x: "Apr-2017",
        y: "17.4",
      },
      {
        x: "May-2017",
        y: "4.87",
      },
      {
        x: "Jun-2017",
        y: "-11.17",
      },
      {
        x: "Jul-2017",
        y: "8.56",
      },
      {
        x: "Aug-2017",
        y: "11.84",
      },
      {
        x: "Sep-2017",
        y: "6.91",
      },
      {
        x: "Oct-2017",
        y: "-5.3",
      },
      {
        x: "Nov-2017",
        y: "4.51",
      },
      {
        x: "Dec-2017",
        y: "-0.18",
      },
      {
        x: "Jan-2018",
        y: "-1.25",
      },
      {
        x: "Feb-2018",
        y: "3.7",
      },
      {
        x: "Mar-2018",
        y: "0.44",
      },
      {
        x: "Apr-2018",
        y: "4.89",
      },
      {
        x: "May-2018",
        y: "19.64",
      },
      {
        x: "Jun-2018",
        y: "34.21",
      },
      {
        x: "Jul-2018",
        y: "-0.45",
      },
      {
        x: "Aug-2018",
        y: "-1.03",
      },
      {
        x: "Sep-2018",
        y: "-5.57",
      },
      {
        x: "Oct-2018",
        y: "0.38",
      },
      {
        x: "Nov-2018",
        y: "-0.91",
      },
      {
        x: "Dec-2018",
        y: "-2.01",
      },
      {
        x: "Jan-2019",
        y: "-2.68",
      },
      {
        x: "Feb-2019",
        y: "-4.36",
      },
      {
        x: "Mar-2019",
        y: "-6.84",
      },
      {
        x: "Apr-2019",
        y: "-19.93",
      },
      {
        x: "May-2019",
        y: "-26.03",
      },
      {
        x: "Jun-2019",
        y: "-24.07",
      },
      {
        x: "Jul-2019",
        y: "-35.95",
      },
      {
        x: "Aug-2019",
        y: "-42.36",
      },
      {
        x: "Sep-2019",
        y: "-33.4",
      },
      {
        x: "Oct-2019",
        y: "-6.34",
      },
      {
        x: "Nov-2019",
        y: "-10.83",
      },
      {
        x: "Dec-2019",
        y: "-8.4",
      },
      {
        x: "Jan-2020",
        y: "-8.1",
      },
      {
        x: "Feb-2020",
        y: "-8.77",
      },
      {
        x: "Mar-2020",
        y: "-53.31",
      },
    ],
  },
]

export const homeLoansGrowthFall = [
  {
    id: "Home Loans",
    data: [
      { x: "2009-10", y: "13.10%" },
      { x: "2010-11", y: "127.20%" },
      { x: "2011-12", y: "-3.80%" },
      { x: "2012-13", y: "26.60%" },
      { x: "2013-14", y: "37.30%" },
      { x: "2014-15", y: "9.80%" },
      { x: "2015-16", y: "31.50%" },
      { x: "2016-17", y: "-4.20%" },
      { x: "2017-18", y: "1.00%" },
      { x: "2018-19", y: "62.10%" },
      { x: "2019-20", y: "-3.60%" },
    ],
  },
]

export const yearlyReturnsRBIHousePriceIndex = [
  {
    id: "House Price Index",
    data: [
      { x: "Jun-2011", y: "23.14" },
      { x: "Sep-2011", y: "19.64" },
      { x: "Dec-2011", y: "26.26" },
      { x: "Mar-2012", y: "25.8" },
      { x: "Jun-2012", y: "22.93" },
      { x: "Sep-2012", y: "23.2" },
      { x: "Dec-2012", y: "25.1" },
      { x: "Mar-2013", y: "19.91" },
      { x: "Jun-2013", y: "13.81" },
      { x: "Sep-2013", y: "15.02" },
      { x: "Dec-2013", y: "10.06" },
      { x: "Mar-2014", y: "12.25" },
      { x: "Jun-2014", y: "15.83" },
      { x: "Sep-2014", y: "14.07" },
      { x: "Dec-2014", y: "16.9" },
      { x: "Mar-2015", y: "17.51" },
      { x: "Jun-2015", y: "14.52" },
      { x: "Sep-2015", y: "13.06" },
      { x: "Dec-2015", y: "9.75" },
      { x: "Mar-2016", y: "3.3" },
      { x: "Jun-2016", y: "7.34" },
      { x: "Sep-2016", y: "7.65" },
      { x: "Dec-2016", y: "8.34" },
      { x: "Mar-2017", y: "10.45" },
      { x: "Jun-2017", y: "8.7" },
      { x: "Sep-2017", y: "7.45" },
      { x: "Dec-2017", y: "7.2" },
      { x: "Mar-2018", y: "6.69" },
      { x: "Jun-2018", y: "5.33" },
      { x: "Sep-2018", y: "5.67" },
      { x: "Dec-2018", y: "4.66" },
      { x: "Mar-2019", y: "3.64" },
      { x: "Jun-2019", y: "3.44" },
      { x: "Sep-2019", y: "2.81" },
      { x: "Dec-2019", y: "3.45" },
    ],
  },
]

export const nonBankingFinCompanies = [
  {
    id: "NBFCs",
    color: "hsl(119, 70%, 50%)",
    data: [
      { x: "Jun-2014", y: "3057000.00" },
      { x: "Sep-2014", y: "2925000.00" },
      { x: "Dec-2014", y: "2984850.00" },
      { x: "Mar-2015", y: "3117440.00" },
      { x: "Jun-2015", y: "3117890.00" },
      { x: "Sep-2015", y: "2960580.00" },
      { x: "Dec-2015", y: "3149290.00" },
      { x: "Mar-2016", y: "3527420.00" },
      { x: "Jun-2016", y: "3450840.00" },
      { x: "Sep-2016", y: "3701280.00" },
      { x: "Dec-2016", y: "3221050.00" },
      { x: "Mar-2017", y: "3910320.00" },
      { x: "Jun-2017", y: "3410130.00" },
      { x: "Sep-2017", y: "3862370.00" },
      { x: "Dec-2017", y: "3681990.00" },
      { x: "Mar-2018", y: "4963930.00" },
      { x: "Jun-2018", y: "4616410.00" },
      { x: "Sep-2018", y: "5466590.00" },
      { x: "Dec-2018", y: "5709460.00" },
      { x: "Mar-2019", y: "6412080.00" },
      { x: "Jun-2019", y: "6350980.00" },
      { x: "Sep-2019", y: "7135100.00" },
      { x: "Dec-2019", y: "7285610.00" },
      { x: "Mar-2020", y: "8073830.00" },
    ],
  },
]
